import React, { PropsWithChildren } from "react";

import { useAuthContext } from "context/auth";

import useUserApi from "hooks/api/private/useUserApi";

function RefreshTokenService({ children }: PropsWithChildren<{}>) {
    const intervalRef = React.useRef<NodeJS.Timer | null>(null);

    const { refreshToken } = useUserApi();

    const { setAccessToken } = useAuthContext();

    const refreshTokenAction = React.useCallback(() => {
        const [apiCall] = refreshToken(null, { rejectHttpError: true });

        apiCall
            .then((response) => {
                setAccessToken(response.token);
            })
            .catch((error) => console.log(error));
    }, [refreshToken, setAccessToken]);

    React.useEffect(() => {
        intervalRef.current = setInterval(() => {
            refreshTokenAction();
        }, 60000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);

                intervalRef.current = null;
            }
        };
    }, [refreshTokenAction]);

    return <>{children}</>;
}

export default RefreshTokenService;
